import { CONSTANTS_GENERATION__slider_step } from '@shared/constants/CONSTANTS_GENERATION__slider_step';
import { CONSTANTS_GENERATION__value_range } from '@shared/constants/CONSTANTS_GENERATION__value_range';
import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_GRAPH__instance } from '../../../_graph/DTO_GRAPH__instance';
import { DECORATOR__ui_without_component } from '../../_base/_decorators/DECORATOR__ui_without_component';
import { ENUM__field_graph_interaction } from '../../_base/_enums/ENUM__field_graph_interaction';
import { ENUM__field_connectable_type } from '../../_base/_methods/ENUM__field_connectable_type';
import { FIELD__base_visible_connectable } from '../../_base/FIELD__base_connectable';
import { DECORATOR__class_serialization_tested } from '../../_primitives/_base/DECORATOR__class_serialization_tested';
import { DECORATOR__class_serialization_tested_for_hash } from '../../_primitives/_base/DECORATOR__class_serialization_tested_for_hash';
import { DECORATOR__field_not_linked } from '../../_primitives/_base/DECORATOR__field_not_linked';
import { FIELD_PRIMITIVE__bool } from '../../_primitives/FIELD_PRIMITIVE__bool';
import { FIELD_PRIMITIVE__float } from '../../_primitives/number/FIELD_PRIMITIVE__float';
import { FIELD_PRIMITIVE__string_hash_ml_asset } from '../../_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';

@DECORATOR__class_serialization_tested
@DECORATOR__class_serialization_tested_for_hash
export class FIELD__ml_asset_lora extends FIELD__base_visible_connectable {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_ML_ASSET_LORA;

  /*
   *
   */
  static sort_by_hash(a: FIELD__ml_asset_lora, b: FIELD__ml_asset_lora) {
    let hash_a = a.model.get_value();
    let hash_b = b.model.get_value();

    return hash_a.localeCompare(hash_b);
  }

  /*
   * FIELDS
   */
  @FIELD_PRIMITIVE__bool.init_as_field(
    { value: false },
    { graph__interaction: ENUM__field_graph_interaction.VISIBLE_NON_CONNECTABLE, ui__has_component: false },
  )
  is_enabled!: FIELD_PRIMITIVE__bool;

  @FIELD_PRIMITIVE__string_hash_ml_asset.init_field_with_type(ENUM__ml_asset_type.LORA, {
    graph__interaction: ENUM__field_graph_interaction.VISIBLE_NON_CONNECTABLE,
  })
  model!: FIELD_PRIMITIVE__string_hash_ml_asset;

  @FIELD_PRIMITIVE__float.init_as_field(
    {
      value: 1.0,
      value_range: CONSTANTS_GENERATION__value_range.WEIGHT_RANGE,
      values_allowed: CONSTANTS_GENERATION__value_range.WEIGHT_ALLOWED,
      //
      slider_step: CONSTANTS_GENERATION__slider_step.WEIGHT_DEFAULT,
      slider_step_values: CONSTANTS_GENERATION__slider_step.WEIGHT_VALUES,
    },
    { graph__interaction: ENUM__field_graph_interaction.VISIBLE_NON_CONNECTABLE, ui__has_component: false },
  )
  weight!: FIELD_PRIMITIVE__float;

  /*
   * PROPERTIES
   */

  field_connectable__value(graph: DTO_GRAPH__instance) {
    return this.model.find_source(graph).field_connectable__value(graph);
  }

  field_connectable__type() {
    return ENUM__field_connectable_type.ML_ASSET__LORA;
  }

  @DECORATOR__field_not_linked()
  has_effect_on_generation_runtime(graph: DTO_GRAPH__instance) {
    if (!this.is_enabled.get_value()) return false;
    if (this.weight.get_value() == 0) return false;

    return super.has_effect_on_generation_runtime(graph);
  }

  /*
   *  EVENTS
   */

  /*
   * METHODS
   */

  @DECORATOR__ui_without_component
  post_init(): void {
    super.post_init();

    this.model.meta.ui__has_component = false;
  }

  @DECORATOR__field_not_linked()
  store__serialization_keys_list_white_for_hash(): string[] {
    let out: (keyof this)[] = [];

    out.push('model');
    out.push('weight');
    out.push('is_enabled');

    return out as string[];
  }

  /*
   *
   */
}
